import styles from "./Footer.module.css"
import { FaDiscord, FaGithub, FaTwitter } from "react-icons/fa"
import { BsMedium } from "react-icons/bs"


const Footer = () => {
  return (
      <div className={styles.footer}>
          <div className={styles.footer_container}>
          <a href="#">
              <FaTwitter  size={20} />
              <span>Twitter</span>
          </a>
          <a href="#">
              <FaDiscord  size={20} />
              <span>Discord</span>
          </a>
          <a href="#">
              <BsMedium  size={20} />
              <span>Medium</span>
          </a>
          <a href="#">
              <FaGithub  size={20} />
              <span>Github</span>
          </a>
          <a href="#">
              <span>Docs</span>
          </a>
          </div>
            
          
      </div>
  )
}

export default Footer